module.exports = __webpack_public_path__ + "static/media/spinner.54a6df23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/spinner.svg
// module id = 528
// module chunks = 1